<template>
    <div v-if="invitations.length" class="invitation-wrapper">
        <div v-if="allowLike && currentUserInvitation && null === currentUserInvitation.decision" class="invitation-open-response-info">
            <div><strong>Rückmeldung offen</strong></div>
            <div>
                Treffen Sie eine Entscheidung, ob Sie dem {{entryType}} zu- oder absagen.
                <span v-if="endDate">
                        Die Frist für Zu- und Absagen endet am
                    <span v-text="deadlineText"></span>.
                </span>
            </div>
            <div class="row spacer-15">
                <div class="col-6 col-md-3 col-xl-2">
                        <span class="pointer" @click="accept">
                            <i class="material-icons md-18" aria-hidden="true" role="img">thumb_up</i>&nbsp;<strong>Zusagen</strong>
                        </span>
                </div>
                <div class="col-6 col-md-3 col-xl-2">
                        <span class="pointer" @click="reject">
                            <i class="material-icons md-18" aria-hidden="true" role="img">thumb_down</i>&nbsp;<strong>Absagen</strong>
                        </span>
                </div>
            </div>
        </div>
        <div v-else-if="endDate && hasVoted && !hasExpired" class="invitation-open-response-info">
                <span>
                    Die Frist für Zu- und Absagen endet am
                    <span v-text="deadlineText"></span>.
                </span>
        </div>
        <div v-else-if="showStatus && currentUserInvitation && endDate && hasExpired" class="invitation-open-response-info">
                <span>
                    Die Frist für Zu- und Absagen ist abgelaufen.
                </span>
        </div>

        <tab-bar-labels :group="group" class="no-grow draw-bottom-line" :labels-classes="['default-padding-horizontal']" ref="tab-bar-labels">
            <tab-bar-label name="all" :group="group">
                {{allowLike ? 'Eingeladen' : 'Teilnehmer'}} <span class="text-grey">({{invitations.length}})</span>
            </tab-bar-label>

            <template v-if="showStatus">
                <tab-bar-label v-if="acceptedInvitations.length" name="accepted" :group="group">
                    Zusagen <span class="text-grey">({{acceptedInvitations.length}})</span>
                </tab-bar-label>

                <tab-bar-label v-if="rejectedInvitations.length" name="rejected" :group="group">
                    Absagen <span class="text-grey">({{rejectedInvitations.length}})</span>
                </tab-bar-label>

                <tab-bar-label v-if="openInvitations.length" name="open" :group="group">
                    Rückmeldung offen <span class="text-grey">({{openInvitations.length}})</span>
                </tab-bar-label>
            </template>

            <tab-bar-label v-if="allowLike && hasVoted" name="my-invitation" :group="group">
                Meine Entscheidung
            </tab-bar-label>
        </tab-bar-labels>

        <tab-bar-content name="all" :group="group" class="default-padding">
            <div v-if="allCount && allInvitations.length === allCount">
                <div class="infobox infobox-border">
                    {{allowLike ? 'Es wurden alle Nutzer eingeladen.' : 'Es nehmen alle Nutzer teil.'}}
                </div>
            </div>
            <div v-else class="user-container-list user-container-margin-fix">
                <div v-for="invitation in allInvitations" :key="'invitations-all-' + invitation.user">
                    <person-box-user :id="invitation.user">
                        <template v-if="invitation.is_multi_login" #default>
                            Multi-Login
                        </template>
                    </person-box-user>
                </div>
            </div>
        </tab-bar-content>

        <template v-if="showStatus">
            <tab-bar-content v-if="acceptedInvitations.length" name="accepted" :group="group" class="default-padding">
                <div class="user-container-list user-container-margin-fix">
                    <div v-for="invitation in acceptedInvitations" :key="'invitations-accepted-' + invitation.user">
                        <person-box-user :id="invitation.user">
                            <template v-if="invitation.is_multi_login" #default>
                                Multi-Login
                            </template>
                        </person-box-user>
                    </div>
                </div>
            </tab-bar-content>

            <tab-bar-content v-if="rejectedInvitations.length" name="rejected" :group="group" class="default-padding">
                <div class="user-container-list user-container-margin-fix">
                    <div v-for="invitation in rejectedInvitations" :key="'invitations-rejected-' + invitation.user">
                        <person-box-user :id="invitation.user"/>
                    </div>
                </div>
            </tab-bar-content>

            <tab-bar-content v-if="openInvitations.length" name="open" :group="group" class="default-padding">
                <div class="user-container-list user-container-margin-fix">
                    <div v-for="invitation in openInvitations" :key="'invitations-open-' + invitation.user">
                        <person-box-user :id="invitation.user"/>
                    </div>
                </div>
            </tab-bar-content>
        </template>

        <tab-bar-content v-if="allowLike && hasVoted" name="my-invitation" :group="group">
            <div class="invitation-open-response-info no-border-top">
                <template v-if="currentUser.isMultiLogin">
                    Multi-Logins können nicht Absagen.
                </template>
                <template v-else-if="currentUserInvitation">
                    <div><strong>Rückmeldung ändern</strong></div>
                    <div>Sie können Ihre Entscheidung ändern, treffen Sie dazu eine andere Wahl.</div>
                    <div class="row spacer-15">
                        <div class="col-6 col-md-3 col-xl-2">
                            <span class="pointer" :class="{'invitation-is-accepted': STATUS_LIKE === currentUserInvitation.decision}" @click="accept">
                                <i class="material-icons md-18" aria-hidden="true" role="img">thumb_up</i>&nbsp;<strong>Zusagen</strong>
                            </span>
                        </div>
                        <div class="col-6 col-md-3 col-xl-2">
                            <span class="pointer" :class="{'invitation-is-rejected': STATUS_DISLIKE === currentUserInvitation.decision}" @click="reject">
                                <i class="material-icons md-18" aria-hidden="true" role="img">thumb_down</i>&nbsp;<strong>Absagen</strong>
                            </span>
                        </div>
                    </div>
                </template>
            </div>
        </tab-bar-content>
    </div>
</template>

<script setup lang="ts">
    import AppPopup from '@/components/AppPopup.vue';
    import {usePortuna} from '@/composables/portuna';
    import axios from 'axios';
    import {STATUS_DISLIKE, STATUS_LIKE, STATUS_NONE} from '@/library/intranet/likeHandler';
    import Loader from '@/library/intranet/loader';
    import {Popup, popupDefaultCancelButton} from '@/library/popup';
    import TopMessageHandler from '@/library/topMessageHandler';
    import {removeSurnameAffix, sortableCompareStrings} from '@/library/utils';
    import {deepCopyObject, errorHandler, XHR_STATUS_DEFAULT} from '@/utils/portuna';
    import dateHelper from '@/utils/portuna/dateHelper';
    import PersonBoxUser from './PersonBoxUser.vue';
    import TabBarContent from './TabBarContent.vue';
    import TabBarLabel from './TabBarLabel.vue';
    import TabBarLabels from './TabBarLabels.vue';
    import {useStore} from 'vuex';
    import {computed, ref, watch} from 'vue';

    const portuna     = usePortuna();
    const currentUser = portuna.currentUser;

    interface InternalInvitationData extends InvitationData
    {
        name: string;
        surname: string;
    }

    const emit = defineEmits<{
        (eventName: 'revert'): void;
        (eventName: 'approve'): void;
        (eventName: 'reject'): void;
    }>();

    const props = withDefaults(
        defineProps<{
            modelValue: InvitationData[];
            responseUrl: string;
            group?: string;
            entryType?: string;
            entryTitle?: string;
            cols?: string;
            isPopup?: boolean;
            showPopup?: Nullable<LikeStatus>;
            allowLike?: boolean;
            showStatus?: boolean;
            allCount?: number;
            endDate?: Nullable<string>;
            endTime?: Nullable<string>;
        }>(),
        {
            group: 'invitations',
            entryType: 'Eintrag',
            entryTitle: '',
            cols: 'col-12 col-sm-6 col-md-4 col-xl-3 col-xxl-2',
            isPopup: false,
            showPopup: null,
            allowLike: true,
            showStatus: true,
            allCount: 0,
            endDate: null,
            endTime: null,
        },
    );

    const store = useStore();

    const invitations = ref<InvitationData[]>([]);

    const currentUserInvitation = computed((): Nullable<InvitationData> =>
    {
        let userInvitation = null;
        for (let invitation of invitations.value)
        {
            if (invitation.user === currentUser.value.id)
            {
                userInvitation = invitation;

                break;
            }
        }

        return userInvitation;
    });

    const hasVoted = computed(() =>
    {
        return (
            props.allowLike && currentUserInvitation.value && null !== currentUserInvitation.value.decision
        );
    });

    const deadlineText = computed((): string =>
    {
        let text = dateHelper('d.m.Y', props.endDate) as string;
        if (props.endTime)
        {
            text += ', ' + props.endTime + ' Uhr';
        }

        return text;
    });

    const hasExpired = computed((): boolean =>
    {
        const endDateTime = new Date(
            props.endDate + (props.endTime ? ' ' + props.endTime + ':00' : ' 00:00:00'),
        );

        const nowDateTime = new Date();

        return endDateTime.getTime() < nowDateTime.getTime();
    });

    const allInvitations = computed((): InternalInvitationData[] =>
    {
        return getInvitationsData();
    });

    const acceptedInvitations = computed((): InternalInvitationData[] =>
    {
        return getInvitationsData(STATUS_LIKE);
    });

    const rejectedInvitations = computed((): InternalInvitationData[] =>
    {
        return getInvitationsData(STATUS_DISLIKE);
    });

    const openInvitations = computed((): InternalInvitationData[] =>
    {
        return getInvitationsData(STATUS_NONE);
    });

    const createPopup = async (options: PopupOptions): Promise<AppPopup> => store.dispatch('createPopup', options);

    const getInvitationsData = (filter?: Nullable<number>): InternalInvitationData[] =>
    {
        let _invitations = deepCopyObject(invitations.value) as InternalInvitationData[];
        if ('undefined' !== typeof filter)
        {
            _invitations = _invitations.filter((invite) =>
            {
                return filter === invite.decision;
            });
        }

        for (let invite of _invitations)
        {
            const surname  = store.getters.personData(invite.user, 'user').surname;
            // only required for sort - so remove affix
            invite.surname = surname
                ? removeSurnameAffix(store.getters.personData(invite.user, 'user').surname)
                : surname;
        }

        _invitations.sort((a, b) => sortableCompareStrings(a.surname, b.surname));

        return _invitations;
    };

    const accept = () =>
    {
        const userInvitation = currentUserInvitation.value;
        if (userInvitation)
        {
            const response = STATUS_LIKE !== userInvitation.decision;

            Loader.show(response ? 'Dem Eintrag wird zugesagt' : 'Die Zusage wird zurückgezogen');

            axios
            .post(props.responseUrl, {
                user: userInvitation.user,
                status: STATUS_LIKE,
            })
            .then(({
                data: {
                    status,
                    message,
                },
            }) =>
            {
                if (XHR_STATUS_DEFAULT === status)
                {
                    userInvitation.decision = response ? STATUS_LIKE : STATUS_NONE;

                    TopMessageHandler.success(
                        response ? 'Dem Eintrag wurde zugesagt.' : 'Die Zusage wurde zurückgezogen.',
                    );

                    if (!response && 'my-invitation' === store.state.tabBar[props.group].active)
                    {
                        store.commit('updateTabBar', {
                            group: props.group,
                            data: Object.assign({}, store.state.tabBar[props.group], {active: 'all'}),
                        });
                        // this.$emit('revert');
                    }
                    // else
                    // {
                    //     this.$emit('approve');
                    // }
                }
                else
                {
                    errorHandler(message);
                }
            })
            .catch(errorHandler)
            .finally(Loader.hide);
        }
    };

    const reject = () =>
    {
        const userInvitation = currentUserInvitation.value;
        if (userInvitation)
        {
            const response = STATUS_DISLIKE !== userInvitation.decision;

            Loader.show(response ? 'Der Eintrag wird abgesagt' : 'Die Absage wird zurückgezogen');

            axios
            .post(props.responseUrl, {
                user: userInvitation.user,
                status: STATUS_DISLIKE,
            })
            .then(({
                data: {
                    status,
                    message,
                },
            }) =>
            {
                if (XHR_STATUS_DEFAULT === status)
                {
                    userInvitation.decision = response ? STATUS_DISLIKE : STATUS_NONE;

                    TopMessageHandler.success(
                        response ? 'Dem Eintrag wurde abgesagt.' : 'Die Absage wurde zurückgezogen.',
                    );

                    if (!response && 'my-invitation' === store.state.tabBar[props.group].active)
                    {
                        store.commit('updateTabBar', {
                            group: props.group,
                            data: Object.assign({}, store.state.tabBar[props.group], {active: 'all'}),
                        });
                        // this.$emit('revert');
                    }
                    // else
                    // {
                    //     this.$emit('reject');
                    // }
                }
                else
                {
                    errorHandler(message);
                }
            })
            .catch(errorHandler)
            .finally(Loader.hide);
        }
    };

    const openPopup = (action: LikeStatus) =>
    {
        // do notting if ...
        if (
            // invalid action
            (action !== STATUS_LIKE && action !== STATUS_DISLIKE) ||
            // user isn't invited
            !currentUserInvitation.value ||
            // the action is already set
            currentUserInvitation.value.decision === action
        )
        {
            return;
        }

        let headline,
            text,
            icon,
            iconClass: ButtonType,
            actionName;

        const entryTitle = props.entryTitle ? `"<strong>${props.entryTitle}</strong>" ` : '';

        if (STATUS_LIKE === action)
        {
            headline   = `${props.entryType} zusagen`;
            text       = `Möchten Sie dem ${props.entryType} ${entryTitle}wirklich <strong>zusagen</strong>?`;
            icon       = 'thumb_up';
            iconClass  = 'success';
            actionName = 'Zusagen';
        }
        else
        {
            headline   = `${props.entryType} absagen`;
            text       = `Möchten Sie dem ${props.entryType} ${entryTitle}wirklich <strong>absagen</strong>?`;
            icon       = 'thumb_down';
            iconClass  = 'danger';
            actionName = 'Absagen';
        }

        createPopup({
            title: headline,
            titleIcon: icon,
            text: text,
            textIcon: icon,
            textIconClass: 'text-' + iconClass,
            size: 'small',
            buttons: [
                Object.assign({}, popupDefaultCancelButton, {
                    title: 'Nein',
                }),
                {
                    title: actionName,
                    icon: icon,
                    type: iconClass,
                    cmd: (popup: Popup) =>
                    {
                        popup.close();

                        if (STATUS_LIKE === action)
                        {
                            accept();
                        }
                        else
                        {
                            reject();
                        }
                    },
                },
            ],
        }).then((popup) => popup.open());
    };

    invitations.value = props.modelValue;

    if (props.showPopup !== null)
    {
        openPopup(props.showPopup);
    }

    watch(() => props.modelValue, () =>
    {
        invitations.value = props.modelValue;
    }, {deep: true});

    defineExpose(Object.assign({}, portuna, {
        componentName: 'AppInvitations',
    }));
</script>